import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export type ThemePref = 'dark' | 'light' | 'system';

const KEY = 'admin.theme';

function readPref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'dark' || v === 'light' || v === 'system') return v;
  } catch { /* storage недоступен — тема по умолчанию */ }
  return 'dark';
}

/**
 * Тема панели: тёмная по умолчанию, светлая или «как в системе». Применяется атрибутом
 * data-theme на <html> — все цвета в app.css завязаны на него.
 */
export const useThemeStore = defineStore('theme', () => {
  const pref = ref<ThemePref>(readPref());
  const media = window.matchMedia('(prefers-color-scheme: light)');
  const effective = ref<'dark' | 'light'>('dark');

  function apply() {
    effective.value = pref.value === 'system' ? (media.matches ? 'light' : 'dark') : pref.value;
    document.documentElement.dataset.theme = effective.value;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', effective.value === 'light' ? '#ffffff' : '#0b0e14');
  }

  media.addEventListener('change', apply);
  watch(pref, (v) => {
    try { localStorage.setItem(KEY, v); } catch { /* ignore */ }
    apply();
  });
  apply();

  function toggle() {
    pref.value = effective.value === 'dark' ? 'light' : 'dark';
  }

  return { pref, effective, toggle };
});
